import { render, staticRenderFns } from "./WaitingDownlink.vue?vue&type=template&id=3c9e67e9&scoped=true&"
import script from "./WaitingDownlink.vue?vue&type=script&lang=ts&"
export * from "./WaitingDownlink.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingDownlink.vue?vue&type=style&index=0&id=3c9e67e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9e67e9",
  null
  
)

export default component.exports